import type { SxProps, Theme } from '@mui/material';

/**
 * Small gray caption for field **names** (e.g. i18n "Opis", "Komentarz").
 * Pair with `fieldContentSx` for the value below — same hierarchy as RichTextEditor labels.
 * Not for question text or section headings (use `fieldContentSx` or component-local styles).
 */
export const fieldLabelSx: SxProps<Theme> = {
  display: 'block',
  fontSize: '0.75rem',
  fontWeight: 400,
  color: 'text.secondary',
  lineHeight: 1.4,
  mb: 0.5,
};

/** Body text under field labels — matches RichTextView content under "Opis". */
export const fieldContentSx: SxProps<Theme> = {
  fontSize: '0.875rem',
  fontWeight: 400,
  color: 'text.primary',
  lineHeight: 1.5,
};
